import { useSelector } from 'react-redux';
import moment from 'moment';
import { GAME_TITLE } from '../constants/GameTitle';
import { selectAccountState, selectAccountInfo } from '../selectors/account.selector';
import { useRequireLogin } from './useRequireLogin';
import { selectGuardianInfo } from '../selectors/legal.selector';
import { GAME_GATED_USER_AGE } from '../constants/prize';

interface ContentGateResult {
    isLoggedIn: boolean;
    showEntitlementError: boolean;
    showContentGated: boolean;
    showCabinedMode: boolean;
    showLegalContent: boolean;
    gatedAge: number;
}

export const useContentGate = (gameId: string): ContentGateResult => {
    const isLoggedIn = useRequireLogin();

    const accountState = useSelector(selectAccountState);
    const accountInfo = useSelector(selectAccountInfo);
    const guardianInfo = useSelector(selectGuardianInfo);
    const { hasEsportEntitlement } = accountState;

    const getUserIsGated = (accountInfo: any, gameId: string): boolean => {
        if (!accountInfo?.dateOfBirth) return false;

        const gateUserAge = GAME_GATED_USER_AGE[gameId] || 13;
        const dateOfBirth = moment(accountInfo.dateOfBirth);
        const today = moment();
        const age = today.diff(dateOfBirth, 'years', true);
        return age < gateUserAge;
    };

    const getUserIsCabinedMode = (accountInfo: any): boolean => {
        return accountInfo?.cabinedMode || false;
    };

    const getUserIsMinor = (accountInfo: any): boolean => {
        if (!accountInfo?.dateOfBirth) return false;
        const dateOfBirth = moment(accountInfo.dateOfBirth);
        const today = moment();
        const age = today.diff(dateOfBirth, 'years', true);
        return age < 18;
    };

    const showEntitlementError = hasEsportEntitlement === false && gameId === GAME_TITLE.FORTNITE;
    const showContentGated = getUserIsGated(accountInfo, gameId);
    const showCabinedMode = getUserIsCabinedMode(accountInfo);
    const showLegalContent = getUserIsMinor(accountInfo) && !guardianInfo?.guardianEmail;

    return {
        isLoggedIn,
        showEntitlementError,
        showContentGated,
        gatedAge: GAME_GATED_USER_AGE[gameId || GAME_TITLE.FORTNITE],
        showCabinedMode,
        showLegalContent
    };
};
